// import Vue from 'vue'
// import Router from 'vue-router'

export default [
  {
    path: '/lab/photoFit',
    name: 'photoFit',
    component: function () {
      return import('@/pages/lab/photoFit.vue')
    }
  },
  {
    path: '/lab/stretching',
    name: 'stretching',
    component: function () {
      return import('@/pages/lab/stretching.vue')
    }
  },
  {
    path: '/lab/canvas',
    name: 'canvas',
    component: function () {
      return import('@/pages/lab/canvas.vue')
    }
  },
  {
    path: '/lab/puzzle',
    name: 'puzzle',
    component: function () {
      return import('@/pages/lab/puzzle.vue')
    }
  },
  {
    path: '/lab/aiDraw',
    name: 'aiDraw',
    component: function () {
      return import('@/pages/lab/aiDraw.vue')
    },
  },
  {
    path: '/lab/splitDraw',
    name: 'splitDraw',
    component: function () {
      return import('@/pages/lab/splitDraw.vue')
    },
  },
  {
    path: '/lab/mp-download',
    name: 'mpDownload',
    component: function () {
      return import('@/pages/lab/mp-download.vue')
    },
  }
]


// WEBPACK FOOTER //
// ./src/router/modules/lab.js